<div class="progress-container">
  <div class="progress-bar">
    <div class="progress-bar-value">
      <span class="sr-only" *ngIf="displayeMessage">Loading...</span>
    </div>
  </div>
</div>
